import { flexRender } from "@tanstack/react-table";
import "./TableBody.scss";
import { getColumnPinningStylesBody } from "../utils/styleUtils";
import {
  horizontalListSortingStrategy,
  SortableContext,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";

function TableBody({ table, tableOptions, columnOrder, featureOptions }) {
  const { currentPadding } = tableOptions;
  const { enableColumnReording } = featureOptions;
  return (
    <tbody className="ts__body">
      {table.getRowModel().rows.map((row) => (
        <tr className="ts__body__tr" key={row.id}>
          {row.getVisibleCells().map((cell) =>
            !enableColumnReording ? (
              <td
                {...{
                  key: cell.id,
                  style: {
                    ...getColumnPinningStylesBody(cell.column),

                    width: cell.column.getSize(),

                    padding: `${currentPadding}`,
                  },
                  align: cell.column.columnDef.meta?.align || "left",
                  className: "ts__body__td",
                }}
              >
                {cell.getIsGrouped() ? (
                  <>
                    <button onClick={row.getToggleExpandedHandler()}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}{" "}
                      ({row.subRows.length})
                    </button>
                  </>
                ) : cell.getIsAggregated() ? (
                  flexRender(
                    cell.column.columnDef.aggregatedCell ??
                      cell.column.columnDef.cell,
                    cell.getContext()
                  )
                ) : cell.getIsPlaceholder() ? null : (
                  flexRender(cell.column.columnDef.cell, cell.getContext())
                )}
              </td>
            ) : (
              <SortableContext
                key={cell.id}
                items={columnOrder}
                strategy={horizontalListSortingStrategy}
              >
                <DragAlongCell
                  key={cell.id}
                  cell={cell}
                  row={row}
                  tableOptions={tableOptions}
                />
              </SortableContext>
            )
          )}
        </tr>
      ))}
    </tbody>
  );
}

export default TableBody;

function DragAlongCell({ cell, row, tableOptions }) {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  });
  const { currentPadding } = tableOptions;

  const style = {
    opacity: isDragging ? 0.6 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform),
    transition: "width transform 0.2s ease-in-out",
    width: cell.column.getSize(),
    zIndex: isDragging ? 1 : 0,
    padding: `${currentPadding}`,
  };

  return (
    <td
      ref={setNodeRef}
      {...{
        style: {
          ...style,
          ...getColumnPinningStylesBody(cell.column),
        },
        align: cell.column.columnDef.meta?.align || "left",
        className: "ts__body__td",
      }}
    >
      {cell.getIsGrouped() ? (
        <>
          <button onClick={row.getToggleExpandedHandler()}>
            {flexRender(cell.column.columnDef.cell, cell.getContext())} (
            {row.subRows.length})
          </button>
        </>
      ) : cell.getIsAggregated() ? (
        flexRender(
          cell.column.columnDef.aggregatedCell ?? cell.column.columnDef.cell,
          cell.getContext()
        )
      ) : cell.getIsPlaceholder() ? null : (
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
}
